import React, { useState } from "react";

import {
	Validate,
	ValidationRule,
	useFormContext,
	useFormState,
} from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import classNames from "classnames";

import { PopoverMessage } from ".";

export default function FormInputField(props: FormInputFieldProps) {
	const {
		id = undefined,
		label,
		labelClassName,
		inputClassName = undefined,
		name,
		className,
		errorMessage = undefined,
		type = "text",
		required = false,
		placeholder = undefined,
		popoverMsg = null,
		validate,
		asterisksClass = null,
		pattern,
		autoComplete = "off",
		...rest
	} = props;

	const [mouseOverState, setMouseOverState] = useState(false);

	const { t } = useTranslation();
	const { register } = useFormContext();

	const { errors } = useFormState();
	const error = errors?.name;

	const field = register(name, {
		required: {
			value: required,
			message: errorMessage || "COMMON.REQUIRED_FIELD",
		},
		pattern,
		validate,
	});

	const labelClasses = classNames("label", labelClassName);

	const inputClass = classNames(inputClassName, {
		"input input--med":
			inputClassName == undefined || inputClassName == null,
		"input-validation-error": error != undefined,
	});

	if (label == undefined || className == undefined) {
		return (
			<input
				type={type}
				{...field}
				{...rest}
				id={id}
				className={inputClassName}
				placeholder={t(placeholder || "")}
			/>
		);
	}

	return (
		<div className={className}>
			<label
				htmlFor={id}
				className={labelClasses}
				onMouseEnter={() => setMouseOverState(true)}
				onMouseLeave={() => setMouseOverState(false)}
			>
				{t(label)}
				<RequiredMark required={required} />
				<PopoverMessage
					popoverMsg={popoverMsg}
					mouseOverState={mouseOverState}
				/>
			</label>
			<ErrorMessage name={name} />
			<input
				type={type}
				{...field}
				{...rest}
				id={id}
				className={inputClass}
				placeholder={t(placeholder || "")}
				autoComplete={autoComplete}
			/>
		</div>
	);
}

type FormInputFieldProps = Omit<
	React.InputHTMLAttributes<HTMLInputElement>,
	"pattern"
> & {
	name: string;
	label?: string;
	labelClassName?: string;
	inputClassName?: string;
	placeholder?: string;
	popoverMsg?: React.ReactNode | string;
	errorMessage?: string;
	pattern?: ValidationRule<RegExp>;
	//@ts-expect-error
	validate?: Validate<any> | Record<string, Validate<any>>;
	asterisksClass?: string | null;
	autoComplete?: string;
};
